import { render } from "./DocumentCardList.vue?vue&type=template&id=85e67a52"
import script from "./DocumentCardList.vue?vue&type=script&lang=js"
export * from "./DocumentCardList.vue?vue&type=script&lang=js"
script.render = render

export default script